'use client';

import { ComponentProps } from 'react';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';

import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { useLayout } from '@/context/layout-context';
import { CookieWidget } from '@/services/cookieWidget';
import { ZmyleLinks } from '@/utils/paths';

export type ZmyleInfoProps = ComponentProps<'div'>;

export function ZmyleInfo({ className, ...props }: ZmyleInfoProps) {
  const { content } = useLayout();

  const { zmyleFullName, legalInfo, privacyPolicy, cookies } = content.footer;

  const year = new Date().getFullYear();

  const onCookiesClick = () => {
    const zmyleCookieWidget = CookieWidget.getInstance();
    zmyleCookieWidget.open();
  };

  return (
    <div
      className={twMerge(
        'flex flex-col-reverse justify-between pt-5 pb-24 lg:flex-row lg:pb-5',
        className,
      )}
      {...props}
    >
      <div className="flex flex-wrap items-center gap-1 whitespace-nowrap">
        <p>© {year}</p>

        <p>.</p>

        <p>{zmyleFullName}</p>
        <p>.</p>

        <Link
          href={ZmyleLinks.LEGAL_INFO}
          isExternal
          target="_blank"
          className="hover:text-zmyle-secondary"
        >
          {legalInfo}
        </Link>

        <p>.</p>

        <Link
          href={ZmyleLinks.PRIVACY_POLICY}
          isExternal
          target="_blank"
          className="hover:text-zmyle-secondary"
        >
          {privacyPolicy}
        </Link>

        <p>.</p>

        <Button
          variant="link"
          className="hover:text-zmyle-secondary"
          onClick={onCookiesClick}
        >
          {cookies}
        </Button>
      </div>

      <div className="mb-4 flex items-center gap-4 text-base lg:mb-0">
        <Link
          href={ZmyleLinks.INSTAGRAM}
          isExternal
          target="_blank"
          className="bg-zmyle-primary flex rounded p-1 text-white hover:text-white"
          aria-label="Open Instagram profile"
        >
          <FaInstagram />
        </Link>

        <Link
          href={ZmyleLinks.FACEBOOK}
          isExternal
          target="_blank"
          className="bg-zmyle-primary flex rounded p-1 text-white hover:text-white"
          aria-label="Open Facebook page"
        >
          <FaFacebookF />
        </Link>

        <Link
          href={ZmyleLinks.TWITTER}
          isExternal
          target="_blank"
          className="bg-zmyle-primary flex rounded p-1 text-white hover:text-white"
          aria-label="Open Twitter profile"
        >
          <FaTwitter />
        </Link>
      </div>
    </div>
  );
}
